export default __webpack_public_path__ + "static/media/cbcSala6.b0a6284b.jpg";